module.exports = __webpack_public_path__ + "static/geerntet-03-71da74a61db163b88bb39df4bc73ccde.jpg";